import { FORM_FIELDS } from '@AppConfig/FormsConfig';
export const getFormFieldComponent = (tag, type) => {
    return FORM_FIELDS.find(f => f.tag.includes(tag) && f.type.includes(type));
};
